<template>
    <div class="page business-page">
        <div class="loading" v-if="loading"></div>
        <div v-if="!hasAuthInfo">
            <div class="page__hd" v-if="form.name">
                <div class="page__title">{{ form.name }}</div>
                <div class="page__desc">{{ form.corpName }}</div>
            </div>
            <div class="page__bd">
                <div class="weui-form">
                    <div class="weui-form__control-area">
                        <div class="weui-cells__group weui-cells__group_form">
                            <div class="weui-cells__title">伙伴信息</div>
                            <div class="weui-cells">
                                <label class="weui-cell weui-cell_active weui-cell_readonly">
                                    <div class="weui-cell__hd"><span class="weui-label">公司</span></div>
                                    <div class="weui-cell__bd">
                                        <input class="weui-input" v-model="form.partner.corpName" readonly="">
                                    </div>
                                </label>
                                <label class="weui-cell weui-cell_active weui-cell_disabled">
                                    <div class="weui-cell__hd"><span class="weui-label">姓名</span></div>
                                    <div class="weui-cell__bd">
                                        <input class="weui-input" v-model="form.partnerUser.realname" readonly="">
                                    </div>
                                </label>
                                <label class="weui-cell weui-cell_active weui-cell_disabled">
                                    <div class="weui-cell__hd"><span class="weui-label">手机号</span></div>
                                    <div class="weui-cell__bd">
                                        <input class="weui-input" v-model="form.partnerUser.mobile" readonly="">
                                    </div>
                                </label>
                                <label class="weui-cell weui-cell_active weui-cell_disabled"
                                    v-if="form.partnerUser.email">
                                    <div class="weui-cell__hd"><span class="weui-label">邮箱</span></div>
                                    <div class="weui-cell__bd">
                                        <input class="weui-input" v-model="form.partnerUser.email" readonly="">
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="weui-form__opr-area">
                        <a role="button" class="weui-btn weui-btn_primary" href="javascript:" @click="register">保存名片</a>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="hasAuthInfo">
            <div class="page__hd">
                <div class="page__title">{{ authInfo.account.realname }}</div>
                <div class="page__desc">{{ authInfo.account.defaultCompany.name }}</div>
            </div>
            <div class="page__bd">
                <launch-weapp label="进入企业圈" :query="'token=' + authInfo.token" />
            </div>
        </div>
    </div>
</template>

<script>
import Auth from "@/util/auth.js";
import LaunchWeapp from "@/components/button/LaunchWeapp.vue";

export default {
    components: {
        LaunchWeapp,
    },
    data() {
        return {
            form: {
                partner: {},
                partnerUser: {}
            },
            hasAuthInfo: false,
            authInfo: {},
            loading: true,
        };
    },
    created() {
        this.getAuthInfo();
    },
    methods: {
        /**
         * 主动获取cookie身份信息
         */
        getAuthInfo() {
            var me = this;
            Auth.get()
                .then(function (data) {
                    me.loading = false;
                    me.authInfo = data;
                    var account = data.account;
                    me.hasAuthInfo = account && account.companyId;
                    if (!me.hasAuthInfo) {
                        me.getCardInfo();
                    }
                })
                .catch(function () {
                    me.loading = false;
                    me.getCardInfo();
                });
        },
        /**
         * 名片信息
         */
        getCardInfo() {
            var me = this, cardId = me.$route.params.id
            if (!cardId) {
                return
            }
            me.$loading({
                url: "/api/account/business_card/read",
                params: {
                    cardId
                }
            }).then(function (res) {
                if (res.data) {
                    me.form = res.data
                }
            });
        },
        /**
         * 注册
         */
        register() {
            const me = this, cardId = me.$route.params.id
            me.$loading({
                url: "/api/account/business_card/register",
                method: "POST",
                params: {
                    cardId
                },
            }).then(function (res) {
                if (res.success) {
                    let authData = res.data;
                    me.authInfo = Auth.set(authData);
                    me.hasAuthInfo = true;
                    me.$weui.toast("保存成功", 2000);
                } else {
                    me.$weui.topTips("保存失败：" + res.message, 3000);
                }
            });
        },
    },
};
</script>

<style scoped>
.business-page .page__bd .weui-form {
    padding: 0;
}

.business-page .page__bd .weui-form__control-area {
    margin: 20px 0 48px 0;
}

.page__hd {
    padding: 40px;
}

.page__title {
    text-align: left;
    font-size: 20px;
    font-weight: 400;
}

.page__desc {
    margin-top: 4px;
    color: var(--weui-FG-1);
    text-align: left;
    font-size: 14px;
}

.loading {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -80px 0 0 -40px;
    width: 80px;
    height: 80px;
    border: 3px solid #d0d3d4;
    border-top-color: #626567;
    border-radius: 50%;
    animation: spin 1.5s linear infinite;
}

.selector {
    margin: 0px 30px 20px 30px;
    display: flex;
    justify-content: space-between;
}

.selector span {
    width: 40%;
    border: 1px solid #ccc;
    padding: 8px 5px 7px 5px;
    border-radius: 5px;
    text-align: center;
}

.span-selected {
    font-weight: bold;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>

